import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline"
import { ReactComponent as Phone } from "@svgs/phone.svg"
import { ReactComponent as Venue } from "@svgs/venue.svg"
import { ReactComponent as VideoConference } from "@svgs/vc.svg"

const eventAccessSchedules = {
  staff: {
    code: "OPEN_STAFF",
    title: "Schedule Event Access for Staff",
    description: "Schedule when the event will be open to staff. This must be scheduled at least 24 hours before the start of the event.",
    scheduledText: "Event access is scheduled to open on",
    activeText: "Click to remove access.",
    inactiveText: "Allow access now",
    scheduleLinkText: "schedule an opening",
    field: "open_staff",
    deleteSubTitle: "Delete Open to Staff schedule?",
    deleteDescription: "Are you sure you want to delete the current Open to Staff schedule?",
    readOnlyText: "Allow staff to view the event.",
    loadingText: "Updating staff access...",
  },

  parents: {
    code: "OPEN_PARENTS",
    title: "Schedule Event Access for Parents",
    description: "Schedule when the event will be open to parents. This must be scheduled at least 24 hours before the start of the event.",
    scheduledText: "Event access is scheduled to open on",
    activeText: "Click to remove access.",
    inactiveText: "Allow access now",
    scheduleLinkText: "schedule an opening",
    field: "open_parents",
    deleteSubTitle: "Delete Open to Parents schedule?",
    deleteDescription: "Are you sure you want to delete the current Open to Parents schedule?",
    readOnlyText: "Allow parents to view the event.",
    loadingText: "Updating parent access...",
  },
  
  disable_bookings: {
    code: "DISABLE_PARENT_BOOKINGS",
    title: "Schedule Disabling of Parent Bookings",
    description: "Schedule when parent bookings will be disabled. Bookings can be disabled anytime before the event starts.",
    scheduledText: "Parent bookings are scheduled to be disabled on",
    activeText: "Click to enable bookings.",
    inactiveText: "Disable bookings now",
    scheduleLinkText: "schedule disabling",
    field: "disable_parent_bookings",
    deleteSubTitle: "Delete Disable Parent Bookings schedule?",
    deleteDescription: "Are you sure you want to delete the current Disable Parent Bookings schedule?",
    readOnlyText: "Disable parent bookings for this event.",
    loadingText: "Updating parent booking availability...",
  }
}

const meetingTypes = {
  PHONE: { id: 2, image: <Phone className="h-16" />, label: "Telephone", description: "Attend over the phone (we will call you).", badgeColor: "bg-sky-500" },
  VC: { id: 3, image: <VideoConference className="h-16" />, label: "Video Call", description: "Attend with in-app video conferencing.", badgeColor: "bg-lime-500" },
  VENUE: { id: 1, image: <Venue className="h-16" />, label: "Venue", description: "Attend in person.", badgeColor: "bg-purple-500" },
}

const availabilityTypes = {
  AVAILABLE: { id: 1, image: <CheckCircleIcon className="h-10" />, description: "Available for booking.", label: "Available", badgeColor: "bg-green-500", code: "AVAILABLE" },
  DISABLED: { id: 2, image: <XCircleIcon className="h-10" />, description: "Unavailable for booking.", label: "Unavailable", badgeColor: "bg-red-500", code: "DISABLED" },
}

const maxBookingsOptions = [
  { id: 0, label: "Unlimited Bookings" },
  { id: 1, label: "1 Booking per student" },
  { id: 2, label: "2 Bookings per student" },
  { id: 3, label: "3 Bookings per student" },
  { id: 4, label: "4 Bookings per student" },
  { id: 5, label: "5 Bookings per student" },
  { id: 6, label: "6 Bookings per student" },
  { id: 7, label: "7 Bookings per student" },
  { id: 8, label: "8 Bookings per student" },
  { id: 9, label: "9 Bookings per student" },
  { id: 10, label: "10 Bookings per student" },
  { id: 11, label: "11 Bookings per student" },
  { id: 12, label: "12 Bookings per student" },
  { id: 13, label: "13 Bookings per student" },
  { id: 14, label: "14 Bookings per student" },
  { id: 15, label: "15 Bookings per student" },
  { id: 16, label: "16 Bookings per student" },
  { id: 17, label: "17 Bookings per student" },
  { id: 18, label: "18 Bookings per student" },
  { id: 19, label: "19 Bookings per student" },
  { id: 20, label: "20 Bookings per student" },
];

const maxBookingsRestrictedDaysOptions = [
  { id: 0, label: "For the entire event" },
  { id: 1, label: "Until 1 day before the event" },
  { id: 2, label: "Until 2 days before the event" },
  { id: 3, label: "Until 3 days before the event" },
  { id: 4, label: "Until 4 days before the event" },
  { id: 5, label: "Until 5 days before the event" },
  { id: 6, label: "Until 6 days before the event" },
  { id: 7, label: "Until 7 days before the event" },
  { id: 8, label: "Until 8 days before the event" },
  { id: 9, label: "Until 9 days before the event" },
  { id: 10, label: "Until 10 days before the event" },
];

export {
  availabilityTypes,
  eventAccessSchedules,
  meetingTypes,
  maxBookingsOptions,
  maxBookingsRestrictedDaysOptions,
}